import {
    MenuItemProps,
    useTranslationLang,
    useTranslationRoute,
    useTranslations,
} from "@harea/component";
import { useMemo } from "react";

export const useDataMenu = () => {
    const translateRoute = useTranslationRoute();
    const [DETAILS, EVALUATION] = useTranslations(i18n);
    const {lang} = useTranslationLang()

    return useMemo(
        (): Array<MenuItemProps> => [
            {
                ke: "export",
                label: EVALUATION,
                link: translateRoute(`admin/data/export`),
            },
            {
                ke: "import",
                label: DETAILS,
                link: translateRoute(`admin/data/import`),
            },
        ],
        [lang]
    );
};

const i18n = [
    'Harea.Data.Import.Title',
    'Harea.Data.Export.Title',
];
